"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Header = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _HeaderDesktop = require("./HeaderDesktop");

var _HeaderMobile = require("./HeaderMobile");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(_ref) {
  var initials = _ref.initials,
      user = _ref.user,
      email = _ref.email,
      onClickHome = _ref.onClickHome,
      searchPlaceHolder = _ref.searchPlaceHolder,
      onKeyDownDesktopSearch = _ref.onKeyDownDesktopSearch,
      menuItems = _ref.menuItems,
      searchWidth = _ref.searchWidth,
      searchMargin = _ref.searchMargin,
      searchMaxWidth = _ref.searchMaxWidth;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement(_HeaderMobile.HeaderMobile, {
    initials: initials,
    user: user,
    email: email,
    onClickHome: onClickHome,
    menuItems: menuItems,
    searchWidth: searchWidth,
    searchMargin: searchMargin
  })), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement(_HeaderDesktop.HeaderDesktop, {
    initials: initials,
    user: user,
    email: email,
    onClickHome: onClickHome,
    searchPlaceHolder: searchPlaceHolder,
    onKeyDownDesktopSearch: onKeyDownDesktopSearch,
    menuItems: menuItems,
    searchWidth: searchWidth,
    searchMargin: searchMargin,
    searchMaxWidth: searchMaxWidth
  })));
};

exports.Header = Header;
Header.propTypes = {
  /**
   * Iniciais que serao mostradas no avatar do usuario
   */
  initials: _propTypes.default.string.isRequired,

  /**
   * Nome do usuário exibido ao clicar no menu
   */
  user: _propTypes.default.string.isRequired,

  /**
   * Email do usuário exibido ao clicar no menu
   */
  email: _propTypes.default.string.isRequired,

  /**
   * Função requerida para quando o usuário clicar no logotipo presente no header.
   */
  onClickHome: _propTypes.default.func.isRequired,

  /**
   * Mensagem que aparecerá como placeholder da barra de pesquisa
   */
  searchPlaceHolder: _propTypes.default.string,

  /**
   *  Valor que determina em % o tamanho da barra de pesquisa dentro do header
   */
  searchWidth: _propTypes.default.number,

  /**
   * Prop que determina as margens da barra de pesquisa, podendo passar uma string como "0 100px 0 200px", caso as margens sejam de tamanhos iguais, é possivel apenas passar o valor desejado em pixels
   */
  searchMargin: _propTypes.default.string,

  /**
   *  Valor que determina o valor maximo, em pixels, que a barra de pesquisa pode alcançar
   */
  searchMaxWidth: _propTypes.default.number,

  /**
   * Função requerida para quando o usuário pressionar alguma tecla na barra de pesquisa
   */
  onKeyDownDesktopSearch: _propTypes.default.func.isRequired,

  /**
   * Lista de objetos que serão concatenados ao menu (aberto ao clicar no avatar).
   */
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired).isRequired
};
Header.defaultProps = {
  searchPlaceHolder: 'Buscar...',
  searchWidth: 50,
  searchMargin: 'auto',
  searchMaxWidth: 931
};
var _default = Header;
exports.default = _default;